module.exports = __webpack_public_path__ + "static/media/delete.3fa0c152.svg";